import { IAppState } from '../../common/state';

export function selectTotalOffers(state: IAppState): number {
  return state.results.totalOffers;
}
